import { ColoredCell, ResultsRow, RowProps } from 'features/shared/ui/Table';
import React from 'react';
import { parallels, StudentsRowProps } from 'features/monitoring/models';
import TableRowWithTooltip from 'features/shared/TableRowWithTooltip';

type Props = RowProps &
  StudentsRowProps & {
    showSchool: boolean;
  };

export const Row = (props: Props) => (
  <ResultsRow noResults={props.noResults} lowResults={props.lowResults}>
    <td style={{ paddingLeft: '16px', textAlign: 'start' }}>
      <TableRowWithTooltip>{props.location}</TableRowWithTooltip>
    </td>
    {props.showSchool && (
      <td style={{ paddingLeft: '16px', textAlign: 'start' }}>
        <TableRowWithTooltip>{props.school}</TableRowWithTooltip>
      </td>
    )}
    {parallels.map((parallel) => (
      <ColoredCell>{props.studentCounts[parallel] || 0}</ColoredCell>
    ))}
  </ResultsRow>
);
